var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-chat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.64171 8.2383H13.3584M6.64171 11.7616H11.4317M10 17.7083C11.6745 17.7079 13.3034 17.1623 14.6402 16.154C15.977 15.1456 16.9492 13.7294 17.4096 12.1194C17.87 10.5095 17.7937 8.79341 17.1921 7.23071C16.5905 5.66801 15.4965 4.3437 14.0754 3.45805C12.6543 2.57241 10.9834 2.1736 9.3155 2.32194C7.6476 2.47028 6.07335 3.15771 4.83086 4.28026C3.58836 5.4028 2.74518 6.89941 2.42885 8.54375C2.11251 10.1881 2.34022 11.8907 3.07754 13.3941C3.16754 13.5775 3.19754 13.7841 3.15171 13.9825L2.47171 16.9291C2.45254 17.0118 2.45473 17.098 2.4781 17.1797C2.50146 17.2613 2.54521 17.3356 2.60524 17.3956C2.66526 17.4556 2.73958 17.4994 2.82119 17.5227C2.9028 17.5461 2.98901 17.5483 3.07171 17.5291L6.01754 16.8483C6.21643 16.8047 6.42427 16.8312 6.60587 16.9233C7.66203 17.442 8.8234 17.7106 10 17.7083Z",
    stroke: "#5C6777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64171 8.2383H13.3584M6.64171 11.7616H11.4317M10 17.7083C11.6745 17.7079 13.3034 17.1623 14.6402 16.154C15.977 15.1456 16.9492 13.7294 17.4096 12.1194C17.87 10.5095 17.7937 8.79341 17.1921 7.23071C16.5905 5.66801 15.4965 4.3437 14.0754 3.45805C12.6543 2.57241 10.9834 2.1736 9.3155 2.32194C7.6476 2.47028 6.07335 3.15771 4.83086 4.28026C3.58836 5.4028 2.74518 6.89941 2.42885 8.54375C2.11251 10.1881 2.34022 11.8907 3.07754 13.3941C3.16754 13.5775 3.19754 13.7841 3.15171 13.9825L2.47171 16.9291C2.45254 17.0118 2.45473 17.098 2.4781 17.1797C2.50146 17.2613 2.54521 17.3356 2.60524 17.3956C2.66526 17.4556 2.73958 17.4994 2.82119 17.5227C2.9028 17.5461 2.98901 17.5483 3.07171 17.5291L6.01754 16.8483C6.21643 16.8047 6.42427 16.8312 6.60587 16.9233C7.66203 17.442 8.8234 17.7106 10 17.7083Z",
    stroke: "black",
    strokeOpacity: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon-chat.825938a2.svg";
export { ForwardRef as ReactComponent };